<template>
  <div class="full-width-table">
    <sdCards :title="cardTitle" bodypadding="0px">
      <template #button>
        <CardDateNavVue @date-changed="dateChanged" />
      </template>
      <div class="table-bordered top-seller-table table-responsive">
        <a-table :columns="columns" :dataSource="data" :pagination="false" size="small"> </a-table>
      </div>
    </sdCards>
  </div>
</template>

<script>
import CardDateNavVue from '@/components/cards/CardDateNav.vue';

export default {
  components: {
    CardDateNavVue,
  },
  data() {
    return {
      data: null,
      date: 'year',
      columns: [
        {
          title: this.$t('pages.home.table-install-app-name'),
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: this.$t('pages.home.table-install-number'),
          dataIndex: 'sold',
          key: 'sold',
        },
      ],
    };
  },
  props: {
    cardTitle: {
      type: String,
    },
    endpoint: {
      type: String,
    },
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$appAxios.post(this.endpoint, { date: this.date })
        .then(response => {
          if (response.data.status === true) {
            var tableRecords = response.data.data;
            this.data = [];
            var _this = this;
            tableRecords.forEach(item => {
              _this.data.push({
                key: item.app_id,
                name: item.application,
                sold: item.number,
              });
            });
          }
          this.isCard_Loading = false;
        })
        .catch(e => {
        });
    },
    dateChanged(value) {
      this.date = value;
      this.getData();
    },
  },
};
</script>
